const ITEMS = [
  "HEAT PRESS MACHINES — 5 IN 1 & 8 IN 1 COMBO",
  "AAA GRADE SUBLIMATION MUGS",
  "STH BRAND TSHIRTS — OWN MANUFACTURING",
  "MDF FRAMES, CLOCKS & TROPHIES",
  "ROTATING LED PHOTO LAMPS",
  "INSTANT WHATSAPP ORDERING",
];

const COLORS = ["text-cyan-400", "text-fuchsia-500", "text-yellow-300"];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-white/10 bg-[#0F1015] py-5">
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10 font-mono text-sm uppercase tracking-[0.25em]">
                <span className={COLORS[i % 3]}>•</span>
                <span className="text-slate-300">{item}</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
